import ApiService from './ApiService'

export const LeadsService = {
  baseURL: process.env.VUE_APP_LEADS_URL,

  getEntities (params) {
    return new Promise((resolve, reject) => {
      ApiService.query(`${this.baseURL}leadsentities`, params)
        .then(response => resolve(response.data))
        .catch(errors => reject(errors))
    })
  },

  getQuestionnaires(params) {
    return new Promise((resolve, reject) => {
      ApiService.query(`${this.baseURL}/questionnaires`, params)
        .then(response => resolve(response.data))
        .catch(errors => reject(errors))
    })
  },

  exportExcel (params) {
    return ApiService.blob(`${this.baseURL}/excel`, params)
  },

  updateLeadEntity (leadId, params) {
    return ApiService.post(`${this.baseURL}/leads/${leadId}/update-lead-entity`, params)
  },

  getAudProviderForwardingRules (audProviderId) {
    return new Promise((resolve, reject) => {
      ApiService.get(`${this.baseURL}/aud-provider-forwarding-rules/${audProviderId}`)
        .then((response) => resolve(response.data.data))
        .catch((error) => reject(error))
    })
  },

  createRule(data) {
    return new Promise((resolve, reject) => {
      ApiService.post(`${this.baseURL}/aud-provider-forwarding-rules`, data)
        .then((response) => resolve(response.data.data))
        .catch((error) => reject(error))
    })
  },

  deleteRule(ruleId) {
    return new Promise((resolve, reject) => {
      ApiService.delete(`${this.baseURL}/aud-provider-forwarding-rules/${ruleId}`)
        .then((response) => resolve(response.data.data))
        .catch((error) => reject(error))
    })
  },

  addCriteriaToRule(ruleId, data) {
    return new Promise((resolve, reject) => {
      ApiService.post(`${this.baseURL}/aud-provider-forwarding-rules/${ruleId}/criterias`, data)
        .then((response) => resolve(response.data.data))
        .catch((error) => reject(error))
    })
  }
}

export const LeadsAgendaService = {
  baseURL: process.env.VUE_APP_LEADS_URL+"/agenda",

  createEvent(params) {
    return ApiService.post(`${this.baseURL}/events`, params)
  },

  updateEvent(id, params) {
    return ApiService.patch(`${this.baseURL}/events/${id}`, params)
  },

  deleteEvent(id, deleteComment) {
    let params = {}
    if (deleteComment !== null) {
      params.deleteComment = deleteComment
    }
    return ApiService.patch(`${this.baseURL}/events/delete/${id}`, params)
  },

  getEventTypes() {
    return ApiService.get(`${this.baseURL}/events/types`)
  },

  getUsersOptions(facilitiesIds) {
    return ApiService.get(`${this.baseURL}/users-options?facilities=${facilitiesIds}`)
  }
}

export const TagsService = {

  baseURL: process.env.VUE_APP_LEADS_URL,

  query (params) {
    return new Promise((resolve, reject) => {
      ApiService.query(`${this.baseURL}/tags`, params)
        .then(response => resolve(response.data.data))
        .catch(errors => reject(errors))
    })
  },

  get (slug, params = {}) {
    return new Promise((resolve, reject) => {
      ApiService.get(`${this.baseURL}/tags`, slug, params)
        .then(response => resolve(response.data.data))
        .catch(errors => reject(errors))
    })
  },

  store (data) {
    return new Promise((resolve, reject) => {
      ApiService.post(`${this.baseURL}/tags`, data)
        .then(response => {
          resolve(response.data.data)
        }).catch(errors => {
          reject(errors)
        })
    })
  },

  update (resource, params) {
    return new Promise((resolve, reject) => {
      ApiService.put(`${this.baseURL}/tags/${resource}`, params)
        .then(response => resolve(response.data.data))
        .catch(errors => reject(errors))
    })
  },

  destroy (resource) {
    return ApiService.delete(`${this.baseURL}/tags/${resource}`)
  }

}

export const TemplateService = {

  baseURL: process.env.VUE_APP_LEADS_URL,

  query (params) {
    return new Promise((resolve, reject) => {
      ApiService.query(`${this.baseURL}/pdf-templates`, params)
        .then(response => resolve(response.data.data))
        .catch(errors => reject(errors))
    })
  }
}

export const AnonLeadsService = {

  baseURL: process.env.VUE_APP_LEADS_URL,

  getAnonLeadsBySession (url) {
    return new Promise((resolve, reject) => {
      ApiService.query(url)
        .then(response => resolve(response.data))
        .catch(errors => reject(errors))
    })
  },

  updateComment (leadId, data) {
    return new Promise((resolve, reject) => {
      ApiService.patch(`${this.baseURL}/anonleads/${leadId}`, data)
        .then(response => { resolve(response.data.data) })
        .catch(errors => reject(errors))
    })
  }

}

export const KiosksService = {

  baseURL: process.env.VUE_APP_LEADS_URL,

  query (params) {
    return new Promise((resolve, reject) => {
      ApiService.query(`${this.baseURL}/kiosks`, params)
        .then(response => resolve(response.data))
        .catch(errors => reject(errors))
    })
  },

  get (slug, params = {}) {
    return new Promise((resolve, reject) => {
      ApiService.get(`${this.baseURL}/kiosks`, slug, params)
        .then(response => resolve(response.data.data))
        .catch(errors => reject(errors))
    })
  },

  getAllHexnodeDevices(params) {
    return new Promise((resolve, reject) => {
      ApiService.query(`${this.baseURL}/kiosks/hexnode-devices`, params)
        .then(response => resolve(response.data))
        .catch(errors => reject(errors))
    })
  },

  unlicensed () {
    return new Promise((resolve, reject) => {
      ApiService.query(`${this.baseURL}/kiosks/unlicensed`)
        .then(response => resolve(response.data.data))
        .catch(errors => reject(errors))
    })
  },

  update (resource, params) {
    return new Promise((resolve, reject) => {
      ApiService.put(`${this.baseURL}/kiosks/${resource}`, params)
        .then(response => resolve(response.data.data))
        .catch(errors => reject(errors))
    })
  },

  getCalibrations (params) {
    return new Promise((resolve, reject) => {
      ApiService.get(`${this.baseURL}/calibrations`)
        .then(response => resolve(response.data.data))
        .catch(errors => reject(errors))
    })
  }
}

export const LicensesService = {

  baseURL: process.env.VUE_APP_LEADS_URL,

  get (slug, params = {}) {
    return new Promise((resolve, reject) => {
      ApiService.get(`${this.baseURL}/licenses`, slug, params)
        .then(response => resolve(response.data.data))
        .catch(errors => reject(errors))
    })
  },

  store (params) {
    return ApiService.post(`${this.baseURL}/licenses`, params)
  },

  update (resource, params) {
    return ApiService.put(`${this.baseURL}/licenses/${resource}`, params)
  },

  renew (resource, params) {
    return ApiService.post(`${this.baseURL}/licenses/${resource}/renew`, params)
  },

  cancel (resource) {
    return new Promise((resolve, reject) => {
      ApiService.put(`${this.baseURL}/licenses/${resource}/cancel`)
        .then(response => resolve(response.data.data))
        .catch(errors => reject(errors))
    })
  },

  destroy (resource) {
    return ApiService.delete(`${this.baseURL}/licenses/${resource}`)
  }
}

export const LicensePaymentsService = {

  baseURL: process.env.VUE_APP_LEADS_URL,

  query (licenseId, params) {
    return ApiService.query(`${this.baseURL}/licenses/${licenseId}/payments`, params)
  },

  store (licenseId, params) {
    return ApiService.post(`${this.baseURL}/licenses/${licenseId}/payments`, params)
  },

  update (licenseId, paymentId, params) {
    return ApiService.put(`${this.baseURL}/licenses/${licenseId}/payments/${paymentId}`, params)
  },

  destroy (licenseId, paymentId) {
    return ApiService.delete(`${this.baseURL}/licenses/${licenseId}/payments/${paymentId}`)
  }
}

export const EntitiesService = {
  baseURL: process.env.VUE_APP_LEADS_URL,

  query (params) {
    return ApiService.query(`${this.baseURL}/entities`, params)
  }
}

export const HearingLossRulesService = {
  baseURL: process.env.VUE_APP_LEADS_URL,

  store (entityId, params) {
    return new Promise((resolve, reject) => {
      ApiService.post(`${this.baseURL}/entities/${entityId}/hearinglossrules`, params)
        .then(response => resolve(response.data.data))
        .catch(errors => reject(errors))
    })
  },

  update (entityId, slug, params) {
    return new Promise((resolve, reject) => {
      ApiService.patch(`${this.baseURL}/entities/${entityId}/hearinglossrules/${slug}`, params)
        .then(response => resolve(response.data.data))
        .catch(errors => reject(errors))
    })
  },

  destroy (entityId, slug) {
    return ApiService.delete(`${this.baseURL}/entities/${entityId}/hearinglossrules/${slug}`)
  }
}

export const StatisticsService = {

  baseURL: process.env.VUE_APP_LEADS_URL,

  getBasicStats (params) {
    return new Promise((resolve, reject) => {
      ApiService.query(`${this.baseURL}/statistics/v2/stats`, params)
        .then(response => resolve(response.data.data))
        .catch(errors => reject(errors))
    })
  },

  exportCsm (params = {}) {
    return ApiService.blob(`${this.baseURL}/statistics/v2/exportCsm`, params)
  },

  getFullStats (params) {
    return new Promise((resolve, reject) => {
      ApiService.query(`${this.baseURL}/statistics/v2/fullstatshl`, params)
        .then(response => resolve(response.data.data))
        .catch(errors => reject(errors))
    })
  },

  getFullStatsPerDay (params) {
    return new Promise((resolve, reject) => {
      ApiService.query(`${this.baseURL}/statistics/v2/fullstatsDay`, params)
        .then(response => resolve(response.data.data))
        .catch(errors => reject(errors))
    })
  },

  getFsStats (params) {
    return new Promise((resolve, reject) => {
      ApiService.query(`${this.baseURL}/statistics/v2/fsstats`, params)
        .then(response => resolve(response.data.data))
        .catch(errors => reject(errors))
    })
  },

  getPharmaStats (params) {
    return new Promise((resolve, reject) => {
      ApiService.query(`${this.baseURL}/statistics/v2/fullstatspharma`, params)
        .then(response => resolve(response.data.data))
        .catch(errors => reject(errors))
    })
  },

  getCsmStats (params) {
    return new Promise((resolve, reject) => {
      ApiService.query(`${this.baseURL}/statistics/v2/csmstats`, params)
        .then(response => resolve(response.data.data))
        .catch(errors => reject(errors))
    })
  }
}

export const GlinttHierarchyService = {

  baseURL: process.env.VUE_APP_LEADS_URL,

  validateFile (data) {
    return new Promise((resolve, reject) => {
      ApiService.post(`${this.baseURL}/glintt-hierarchy-validate`, data)
        .then(response => resolve(response.data.data))
        .catch(errors => reject(errors))
    })
  },

  importFile (data) {
    return new Promise((resolve, reject) => {
      ApiService.post(`${this.baseURL}/glintt-hierarchy-import`, data)
        .then(response => resolve(response.data.data))
        .catch(errors => reject(errors))
    })
  },

  getUserProfile (resource, params = {}) {
    return new Promise((resolve, reject) => {
      ApiService.query(`${this.baseURL}/users/${resource}/profile`, params)
        .then(response => resolve(response.data.data))
        .catch(errors => reject(errors))
    })
  }
}

export const EntityRequestService = {

  baseURL: process.env.VUE_APP_LEADS_URL,

  getPharmacyByQuery (searchQuery) {
    return new Promise((resolve, reject) => {
      ApiService.get(`${this.baseURL}/entityrequest/sync/${searchQuery}`)
        .then(response => resolve(response.data.data))
        .catch(errors => reject(errors))
    })
  },

  store (params = {}) {
    return new Promise((resolve, reject) => {
      ApiService.post(`${this.baseURL}/entityrequest`, params)
        .then(response => resolve(response.data.data))
        .catch(errors => reject(errors))
    })
  },

  update (resource, params = {}) {
    return new Promise((resolve, reject) => {
      ApiService.patch(`${this.baseURL}/entityrequest/${resource}`, params)
        .then(response => resolve(response.data.data))
        .catch(errors => reject(errors))
    })
  },

  delete (resource) {
    return new Promise((resolve, reject) => {
      ApiService.delete(`${this.baseURL}/entityrequest/${resource}`)
        .then(response => resolve(response))
        .catch(errors => reject(errors))
    })
  },

  confirmEntityRequest (resource) {
    let params = {}
    return new Promise((resolve, reject) => {
      ApiService.post(`${this.baseURL}/createentity/${resource}`, params)
        .then(response => resolve(response))
        .catch(errors => reject(errors))
    })
  }
}

export const PlacingsService = {
  baseURL: process.env.VUE_APP_LEADS_URL,

  store (params = {}) {
    return new Promise((resolve, reject) => {
      ApiService.post(`${this.baseURL}/placings`, params)
        .then(response => resolve(response.data.data))
        .catch(errors => reject(errors))
    })
  },

  update (resource, params = {}) {
    return new Promise((resolve, reject) => {
      ApiService.patch(`${this.baseURL}/placings/${resource}`, params)
        .then(response => resolve(response.data.data))
        .catch(errors => reject(errors))
    })
  },

  delete (resource) {
    return new Promise((resolve, reject) => {
      ApiService.delete(`${this.baseURL}/placings/${resource}`)
        .then(response => resolve(response))
        .catch(errors => reject(errors))
    })
  },
}
